import { ContentsApi } from "@/services/contents-service"
import { defineStore } from "pinia"
import { useSystemFeedback } from "@/stores/systemFeedback"
import type {
  ContentGet,
  ContentViewed,
  CurrentVersion
} from "@/types/contents"
import type { ApiError } from "@/types/api"

export const useContents = defineStore("contents", {
  state: () => {
    return {
      content: {} as ContentGet,
      listAllContents: [] as ContentGet[],
      currentVersion: {} as CurrentVersion,
      highlightContent: {} as ContentGet,
      api: new ContentsApi()
    }
  },

  actions: {
    async getCurrentVersion() {
      try {
        const response = await this.api.getCurrentVersion()
        this.currentVersion = response.data
        return response
      } catch (error) {
        this.currentVersion = {} as CurrentVersion
        this.handleErrors(error as ApiError)
      }
    },

    async getAllContents() {
      try {
        const response = await this.api.getAllContents()
        this.listAllContents = response.data
        return response
      } catch (error) {
        this.listAllContents = [] as ContentGet[]
        this.handleErrors(error as ApiError)
      }
    },

    async getContent(id: number) {
      try {
        const response = await this.api.getContent(id)
        this.content = response.data
        return response
      } catch (error) {
        this.content = {} as ContentGet
        this.handleErrors(error as ApiError)
      }
    },

    async getHighlightContent() {
      try {
        const response = await this.api.getHighlightContent()
        this.highlightContent = response.data
        return response
      } catch (error) {
        this.highlightContent = {} as ContentGet
        this.handleErrors(error as ApiError)
      }
    },

    async markContentAsRead(data: ContentViewed) {
      try {
        const response = await this.api.markContentAsViewed(data)
        return response
      } catch (error) {
        this.handleErrors(error as ApiError)
      }
    },

    handleErrors(error: ApiError) {
      const errorMessage = error?.response
        ? `backend.${error.response.data.detail}`
        : "requestError.default"
      useSystemFeedback().setFeedback({ type: "danger", text: errorMessage })
    }
  }
})
